import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DynamicConnectionService {
  variables: any;

  get dynamicConnectionVariables(): any {
    return this.variables;
  }

  set dynamicConnectionVariables(variables: any) {
    this.variables = variables;
  }
}
((window as any).xplenty as angular.IModule).service(
  'dynamicConnectionService',
  downgradeInjectable(DynamicConnectionService),
);
